import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'

// Redux
import {
  addFriend,
  getQuizResults,
  resetAddFriend,
} from 'app/state/modules/quiz'

// Utils
import analytics from 'app/views/utils/analytics'


class QuizInvite extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      friendName: '',
      friendEmail: '',
      myName: '',
      formError: '',
    }

    this.handleFriendEmailChange = this.handleFriendEmailChange.bind(this)
    this.handleFriendNameChange = this.handleFriendNameChange.bind(this)
    this.handleMyNameChange = this.handleMyNameChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    analytics.page('quiz-invite')
    this.props.getQuizResults(this.props.match.params.id)
  }

  handleFriendEmailChange(e) {
    this.setState({ friendEmail: e.target.value })
  }

  handleFriendNameChange(e) {
    this.setState({ friendName: e.target.value })
  }

  handleMyNameChange(e) {
    this.setState({ myName: e.target.value })
  }

  handleSubmit(e) {
    e.preventDefault()

    const friendName = this.state.friendName.trim()
    const friendEmail = this.state.friendEmail.trim()
    const myName = this.state.myName.trim()

    if (myName === '') {
      this.setState({ formError: 'Your name is required' })
    } else if (friendName === '') {
      this.setState({ formError: 'Friend\'s name is required' })
    } else if (friendEmail === '') {
      this.setState({ formError: 'Friend\'s email is required' })
    } else {
      this.setState({ formError: '' })
      this.props.addFriend(friendName, friendEmail, myName, this.props.results.my_score)
    }
  }

  render() {
    return (
      <div>
        <div className="uk-cover-container uk-background-secondary uk-padding-large uk-padding-remove-bottom uk-padding-remove-top uk-light">
          <div className="uk-section uk-padding-remove-top uk-text-center">
            <Link to={`/quiz/${this.props.match.params.id}/results`}>
              <img src="/static/icons/test.png" style={{ height: 100 }} alt="test" />
              <h2>Security Assessment</h2>
            </Link>
          </div>
        </div>
        <div className="uk-container">
          <div className="uk-section uk-text-center">
            <div data-uk-grid>
              <div className="uk-width-1-5@s uk-width-1-3@l" />
              <div className="uk-width-3-5@s uk-width-1-3@l">
                <form>
                  <fieldset className="uk-fieldset">
                    <legend className="uk-legend">Challenge a Friend!</legend>
                    { this.state.formError !== '' &&
                    <div role="alert" className="alert alert-danger">
                      <span className="uk-label uk-label-danger">Oh snap!</span> <strong className="uk-text-danger">{this.state.formError}</strong>
                    </div>
                    }
                    <p className="uk-text-bold uk-margin-remove uk-padding-small uk-padding-remove-horizontal uk-align-left">
                      My Details
                    </p>
                    <div className="uk-margin">
                      <input
                        id="myName"
                        name="nammyNamemyNamee"
                        type="text"
                        placeholder="My Name"
                        autoComplete="off"
                        required
                        className="uk-input"
                        onChange={this.handleMyNameChange}
                        value={this.state.myName}
                        disabled={this.props.hasReceivedFriends || null}
                      />
                    </div>

                    {(!this.props.hasAddedFriend) ? (
                      <div>
                        <p className="uk-text-bold uk-margin-remove uk-padding-small uk-padding-remove-horizontal uk-align-left">
                        Friend's Details
                        </p>
                        <div className="uk-margin">
                          <input
                            id="friendName"
                            name="friendName"
                            type="text"
                            placeholder="Friend's Name"
                            autoComplete="off"
                            required
                            className="uk-input"
                            onChange={this.handleFriendNameChange}
                            value={this.state.friendName}
                            disabled={this.props.hasReceivedFriends || null}
                          />
                        </div>
                        <div className="uk-margin">
                          <input
                            id="friendEmail"
                            name="friendEmail"
                            type="text"
                            placeholder="Friend's Email Address"
                            autoComplete="off"
                            required
                            className="uk-input"
                            onChange={this.handleFriendEmailChange}
                            value={this.state.friendEmail}
                            disabled={this.props.hasReceivedFriends || null}
                          />
                        </div>
                        <div className="uk-margin uk-align-right">
                          {this.props.isAddingFriend ? (
                            <span data-uk-spinner="" />
                          ) : (
                            <button type="submit" className="uk-button tm-button-primary uk-button-primary " onClick={this.handleSubmit}>Send Invite</button>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <p className="uk-text-success">
                          Your friend has been added.
                        </p>
                        <button
                          className="uk-button uk-button-primary tm-button-primary"
                          onClick={() => {
                            this.setState({
                              friendName: '',
                              friendEmail: '',
                            })
                            this.props.resetAddFriend()
                          }}
                          type="button"
                        >
                          Add Another
                        </button>
                      </div>
                    )}

                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state) => ({
  hasAddedFriend: state.quiz.hasAddedFriend,
  isAddingFriend: state.quiz.isAddingFriend,
  results: state.quiz.results,
})

const mapDispatchToProps = (dispatch) => ({
  addFriend: (friendName, friendEmail, myName, myScore) => { dispatch(addFriend(friendName, friendEmail, myName, myScore)) },
  getQuizResults: (quizId) => { dispatch(getQuizResults(quizId)) },
  resetAddFriend: () => { dispatch(resetAddFriend()) },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizInvite))
